import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Order-set breadcrumb context: its name + the regimen it belongs to (link + name), or no regimen. */
export interface V2OrderSetCrumb {
    label: string;
    regimenPath: string | null;
    regimenName: string | null;
}

/**
 * CB-148 step 4 — dynamic labels for the v2 Regimen/Order-set breadcrumbs, consumed by the global
 * AppBreadcrumb (same pattern as CatalogDetailBreadcrumbService et al.). The v2 screens set their label on load;
 * the breadcrumb's url-driven regexes decide the trail shape and read these labels for the dynamic segments.
 */
@Injectable({ providedIn: 'root' })
export class V2BreadcrumbService {
    private readonly _regimen = new BehaviorSubject<string | null>(null);
    private readonly _medication = new BehaviorSubject<string | null>(null);
    private readonly _orderSet = new BehaviorSubject<V2OrderSetCrumb | null>(null);

    readonly regimen$ = this._regimen.asObservable();
    readonly medication$ = this._medication.asObservable();
    readonly orderSet$ = this._orderSet.asObservable();

    setRegimen(label: string | null): void {
        this._regimen.next(label);
    }
    getRegimen(): string | null {
        return this._regimen.value;
    }
    setMedication(label: string | null): void {
        this._medication.next(label);
    }
    getMedication(): string | null {
        return this._medication.value;
    }
    setOrderSet(v: V2OrderSetCrumb | null): void {
        this._orderSet.next(v);
    }
    getOrderSet(): V2OrderSetCrumb | null {
        return this._orderSet.value;
    }
}
